"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "petralia-sottana": {
    "50dc7fdf": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "carminello": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf1724d1": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d30a7c33": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "provvidenza": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eccdf2c4": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "pusterna": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "88d6be8b": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "233b2bef": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "san-salvatore": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04f11f07": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "spartenza": [{
      "hkey": "1f6f01b5",
      "slug": "petralia-sottana",
      "name": "Petralia Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;